// Add your custom JS here.
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Draggable from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

(function($) {

/* const swiperHeader = new Swiper('.swiper-header', {
  modules: [Navigation],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  speed: 400,
  spaceBetween: 0,
  slidesPerView: 1,
}); */

  const swiperWork = new Swiper('.swiper-work', {
    modules: [Navigation, Pagination, Scrollbar],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 400,
    spaceBetween: 30,
    slidesPerView: 1.025,
    breakpoints: {
      // when window width is >= 480px
      480: {
        slidesPerView: 1.3,
      }
    }
  });

  const swiperService = new Swiper('.swiper-service', {
    modules: [Navigation, Pagination, Scrollbar],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 400,
    spaceBetween: 0,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >= 480px
      480: {
        slidesPerView: 2.1,
      }
    }
  });

  var init = false;
  var swiper;
  function swiperCard() {
    if (window.innerWidth <= 767.98) {
      if (!init) {
        init = true;
        swiper = new Swiper(".servbene-influencers", {
          modules: [Navigation, Pagination, Scrollbar],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          speed: 400,
          spaceBetween: 0,
          slidesPerView: 1,
        });
      }
    } else if (init) {
      swiper.destroy();
      init = false;
    }
  }
  swiperCard();
  window.addEventListener("resize", swiperCard);

  //ScrollTrigger.normalizeScroll(true);

/*   var myOffcanvas = document.getElementById('navbarNavOffcanvas');
  myOffcanvas.addEventListener('show.bs.offcanvas', function () {
    $('.navbar-toggler').addClass('is-active');
  });
  myOffcanvas.addEventListener('hide.bs.offcanvas', function () {
    $('.navbar-toggler').removeClass('is-active');
  }); */

	$('.main-nav-head-btn').on('click', function(e){
		e.preventDefault();
		$('body').toggleClass('main-nav-open');
	});

	if ( window.matchMedia('(min-width: 768px)').matches ) {
		$('.main-nav-head').on('mouseenter', function(){
			$('body').addClass('main-nav-open');
		});
		$('.main-nav').on('mouseleave', function(){
			$('body').removeClass('main-nav-open');
		});
	}

  let sections = gsap.utils.toArray(".hero-slide"),
  getTotalWidth = () => {
    let width = 0;
    sections.forEach(el => width += el.offsetWidth);
    width -= window.innerWidth;
    return width;
  };

  //console.log(getTotalWidth());

  //let _hstart = $('h1').outerHeight()*1.5+'px';

  if ( sections.length > 1 ) {
    gsap.to(".hero-wrapper", {
      //xPercent: -100,
      x: () => -getTotalWidth(),
      ease: "none", // <-- IMPORTANT!
      scrollTrigger: {
        trigger: ".hero",
        pin: true,
        scrub: 1,
        //snap: directionalSnap(1 / (sections.length - 1)),
        start: "top top",
        end: () => "+=" + (document.querySelector('.hero').scrollWidth - window.innerWidth),
      }
    });
  }

    /* gsap.set(sections.slice(1), {scale: 0.7});
    sections.forEach(el => {
      //console.log(el);
      gsap.to(el, {
        scale: 1,
        duration: 0.4,
        //ease: "power3.inOut",
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          containerAnimation: scrollTween,
          start: "left 45%",
          end: "left 5%",
          toggleActions: "play reverse play reverse",
          id: "1",
          //markers: true,
          onEnter: function () {
            $(el).addClass('is-active');
          },
          onLeave: function () {
            $(el).removeClass('is-active');
          },
          onEnterBack: function () {
            $(el).addClass('is-active');
          },
          onLeaveBack: function () {
            $(el).removeClass('is-active');
          },
        }
      });
    }); */

  gsap.utils.toArray(".full-section--clients").forEach(item => {

    ScrollTrigger.create({
      trigger: item,
      start: "top 75%",
      onEnter: function() { 
        $(item).find('.client-list').addClass('active'); 
      },
      onLeaveBack: function() { 
        $(item).find('.client-list').removeClass('active'); 
      },
      //onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
    });
    
  });

  gsap.utils.toArray(".animate-path").forEach(item => {
    ScrollTrigger.create({
      trigger: item,
      start: "top 75%",
      onEnter: function() { 
        $(item).addClass('animated-path');
      },
      onEnterBack: function() { $(item).addClass('animated-path'); },
      onLeave: function() { 
        $(item).removeClass('animated-path'); 
      },
      onLeaveBack: function() { 
        $(item).removeClass('animated-path');
      },
    });
  });

  $('#main-menu a[href^=#]').on('click', function(e){
		e.preventDefault();
    $('.navbar-close').trigger('click');
		var target = $(this).attr('href');
		gsap.to(window, {duration: 0.5, scrollTo: target});
	});

  function animateFrom(elem, direction) {
    direction = direction | 1;
  
    var x = 0,
      y = direction * 100;
    if(elem.classList.contains("gs_reveal_fromLeft")) {
    x = -100;
    y = 0;
    } else if(elem.classList.contains("gs_reveal_fromRight")) {
    x = 100;
    y = 0;
    }
  
    gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
      duration: 1.25,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: "expo",
      overwrite: "auto"
    });
  
  }
  
  function hide(elem) {
    gsap.set(elem, {autoAlpha: 0});
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger);
  
    gsap.utils.toArray(".gs_reveal").forEach(function(elem) {
    hide(elem); // assure that the element is hidden when scrolled into view
  
    ScrollTrigger.create({
      trigger: elem,
      onEnter: function() { animateFrom(elem) },
      onEnterBack: function() { animateFrom(elem, -1) },
      onLeave: function() { hide(elem) } // assure that the element is hidden when scrolled into view
    });
    });
  });

  $(document).ready(function(){
    if ( $('.outline-title.animate-path').length ){
      $('.outline-title.animate-path').each(function(){
        $(this).append(outline);
      });
    }
    if ( $('.outline-title-wide').length ){
      $('.outline-title-wide').each(function(){
        $(this).append(outline_wide);
      });
    }
  });

})( jQuery );